<template>
<div class="main sign-contract">
  <header class="sign-contract-head ptw pbw crw">
    <div class="tac fs2">您已签约俱乐部数量</div>
    <div class="tac mtn fs4">{{clubsAgreed.agreedCnt}}</div>
    <div class="tac mtn">
      <van-button
        @click="searchPanel = true"
        size="small">申请签约</van-button>
    </div>
  </header>
  <van-tabs>
    <van-tab :title="'已签约'">
      <sign-contract-card v-for="(item,index) in clubsAgreed.list" :key="index" :clubInfo="item"></sign-contract-card>
    </van-tab>
    <van-tab :title="'签约申请'">
      <div slot="title">
        签约申请<strong v-if="applyNum!=''" class="red"> ({{applyNum}})</strong>
      </div>
      <sign-contract-card v-for="(item,index) in clubsApplying.list" :key="index" :clubInfo="item"></sign-contract-card>
    </van-tab>
  </van-tabs>
  <van-popup v-model="searchPanel" position="top">
    <van-search
      placeholder="请输入俱乐部名称"
      v-model="searchValue"
      show-action
      @search="onSearch">
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>
    <div v-if="searchClubs.total" class="sign-contract__clubs">
      <sign-contract-card v-for="(item,index) in searchClubs.data" :key="index" :clubInfo="item"></sign-contract-card>
    </div>
    <div v-if="searchClubs.total==0" class="c9 mtw mbw tac">
      ~无~
    </div>
  </van-popup>
</div>
</template>
<script>
import Vue from 'vue';
import {
  Tab,
  Tabs,
  Button,
  Popup,
  Search,
  Toast
} from 'vant';
import SignContractCard from '@/components/SignContractCard';
Vue.use(Tab).use(Tabs).use(Button).use(Popup).use(Search).use(Toast);
export default {
  name: 'SignContract',
  components: {
    SignContractCard
  },
  data(){
    return {
      clubsAgreed:{}, // 已签约的
      clubsApplying:{}, // 申请中的
      searchPanel:false,  // 搜索层
      searchValue:'', // 搜索关键词
      searchClubs:{},  // 搜索到的俱乐部
      applyNum:'',
    }
  },
  created(){
    // 申请中: applying 同意: agreed 拒绝: refused    
    this.$http.get('club_coach/getClubListByCoach?status=agreed').then(res => {
      console.log(res)
      this.clubsAgreed = res.data.value;
    })

    this.$http.get('club_coach/getClubListByCoach?status=applying').then(res => {
      console.log(res)
      this.clubsApplying = res.data.value;
      this.applyNum = res.data.value.list.length
    })
  },
  methods: {
    onSearch: function(){
      // 搜索俱乐部
      if(!this.searchValue){
        Toast.fail('请输入关键词')
        return
      }
      // 加载
      Toast.loading({
        mask: true,
        forbidClick: true,
        duration: 0,
        message: '加载中...'
      });
      this.$http.post('club/getList',{
        title: this.searchValue
      }).then(res => {
        console.log(res)
        Toast.clear()  //关闭
        this.searchClubs = res.data.value
      })
    }
  },
  beforeRouteLeave(to,from,next){
    // 如果搜索层打开 按 返回键是关闭搜索层
    if(this.searchPanel){
      this.searchPanel = false;
      next(false)
    }else{
      next()
    }
  }
}
</script>
<style lang="less">
.sign-contract {
    padding-bottom: 0;
    & .van-tab--active {
        color: #4b0;
    }
    & .van-tabs__line {
        background-color: #4b0;
    }
    &-head {
        background-color: #4b0;
        &__menu {
            padding-right: 0.15rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/SignContract.vue